import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { BlockDataForm, BlocksForm } from '@plone/volto/components/manage/Form';
import { SidebarPortal } from '@plone/volto/components';
import config from '@plone/volto/registry';
import EditBlockWrapper from '@plone/volto/components/manage/Blocks/Block/EditBlockWrapper';
import { comTextoInicial } from '../Destaque/Edit';
import Schema from './schema';
import AvisoView from './View';

/**
 * Edit do Aviso: o mesmo desenho do View, com o texto editável no lugar (blocos
 * do Volto, como no Destaque) e o tipo e o rótulo na barra lateral.
 */
const AvisoEdit = (props) => {
  const {
    block,
    data,
    onChangeBlock,
    selected,
    pathname,
    metadata,
    properties,
    manage,
  } = props;
  const [subBloco, setSubBloco] = useState(null);
  const conteudo = useMemo(
    () => comTextoInicial(data),
    [data?.blocks, data?.blocks_layout], // eslint-disable-line react-hooks/exhaustive-deps
  );
  const schema = Schema();
  const gravarTexto = (novo) => onChangeBlock(block, { ...data, ...novo });
  // Acumulador por render das duas gravações seguidas do volto-slate (ver o
  // Destaque e a sanfona).
  const blockState = {};

  const texto = (
    <BlocksForm
      metadata={metadata || properties}
      properties={conteudo}
      manage={manage}
      selectedBlock={selected ? subBloco : null}
      blocksConfig={config.blocks.blocksConfig}
      isMainForm={false}
      stopPropagation={subBloco}
      onSelectBlock={(id) => setSubBloco(id)}
      onChangeFormData={(novo) =>
        gravarTexto({ blocks: novo.blocks, blocks_layout: novo.blocks_layout })
      }
      onChangeField={(id, value) => {
        if (id === 'blocks' || id === 'blocks_layout') {
          blockState[id] = value;
          gravarTexto({ ...conteudo, ...blockState });
        }
      }}
      pathname={pathname}
    >
      {({ draginfo }, editBlock, blockProps) => (
        <EditBlockWrapper draginfo={draginfo} blockProps={blockProps}>
          {editBlock}
        </EditBlockWrapper>
      )}
    </BlocksForm>
  );

  return (
    <>
      <AvisoView
        data={data}
        metadata={metadata}
        properties={properties}
        texto={texto}
      />
      <SidebarPortal selected={selected}>
        <BlockDataForm
          schema={schema}
          title={schema.title}
          onChangeField={(id, value) =>
            onChangeBlock(block, { ...data, [id]: value })
          }
          formData={data}
          block={block}
        />
      </SidebarPortal>
    </>
  );
};

AvisoEdit.propTypes = {
  block: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
  onChangeBlock: PropTypes.func.isRequired,
  selected: PropTypes.bool,
  pathname: PropTypes.string,
  metadata: PropTypes.object,
  properties: PropTypes.object,
  manage: PropTypes.bool,
};

export default AvisoEdit;
